import { Injectable, inject } from '@angular/core';
import {
  ContextService,
  GlobalStore,
} from '@maximizer/core/shared/data-access';
import {
  EmailEntryType,
  EventAction,
  EventJourney,
  EventModule,
} from '@maximizer/outlook/shared/domain';
import { OutlookStore } from '../state/outlook.store';
import { copyHtmlToClipboard } from '../utils/copy-to-clipboard';
import {
  buildAccountLink,
  buildEntryDeepLink,
  EntryLinkType,
} from '../utils/entry-link.utils';
import { TrackerService } from './tracker.service';

@Injectable({ providedIn: 'root' })
export class EntryLinkService {
  private readonly contextService = inject(ContextService);
  private readonly globalStore = inject(GlobalStore);
  private readonly outlookStore = inject(OutlookStore);
  private readonly tracker = inject(TrackerService);

  buildEntryLink(id: string, type: EntryLinkType): string {
    const session = this.globalStore.session();
    if (!session) {
      return '';
    }

    const accountLink = buildAccountLink(
      this.contextService.website,
      session.alias,
      !!this.outlookStore.isCloud(),
    );
    return buildEntryDeepLink(accountLink, id, type);
  }

  async copyEntryLink(
    id: string,
    type: EmailEntryType,
    trackedEntryType: string,
  ): Promise<boolean> {
    this.tracker.trackEvent({
      module: EventModule.EntryDetails,
      journey: EventJourney.ShareEntry,
      action: EventAction.Clicked,
      metadata: {
        entry: trackedEntryType,
      },
    });

    const entryLink = this.buildEntryLink(id, type);
    if (!entryLink) {
      return false;
    }

    try {
      await copyHtmlToClipboard(entryLink);
      return true;
    } catch {
      return false;
    }
  }
}
